export default {
  // 页面标题
  title: '创建活动',
  editTitle: '编辑活动',
  // 步骤标题
  step1: '基本信息',
  step2: '活动范围',
  step3: '活动奖项',
  step4: '活动策略',
  // 步骤1 - 基本信息
  activityName: '活动名称',
  activityNameRequired: '请输入活动名称',
  activityNamePlaceholder: '请输入活动名称',
  activityTime: '活动时间期间',
  activityTimeRequired: '请选择活动时间期间',
  startTime: '开始时间',
  endTime: '结束时间',
  activityTemplate: '活动模板',
  activityTemplateRequired: '请选择活动模板',
  activityTemplatePlaceholder: '请选择活动模板',
  addTemplate: '+活动模板',
  activityRule: '活动规则',
  rulePlaceholder: '请输入活动规则',
  activityRemark: '活动备注',
  remarkPlaceholder: '请输入活动备注',
  // 步骤2 - 活动范围
  addCode: '添加二维码',
  addCodeTitle: '添加二维码',
  selectCodePlaceholder: '请选择二维码',
  codeEmptyText: '暂无二维码数据',
  codeBatch: '码批次',
  codeRange: '二维码范围',
  codeCount: '二维码数量',
  scopeRemark: '活动范围备注',
  colAction: '操作',
  deleteCode: '删除',
  codeBatchRequired: '请选择码批次',
  codeBatchPlaceholder: '请选择码批次',
  selectCodeBatch: '选择码批次',
  codeRangeType: '二维码范围',
  codeRangeTypeRequired: '请选择二维码范围',
  rangeAll: '整批添加',
  rangePartial: '部分添加',
  rangePartialSerial: '部分添加（流水号区间）',
  rangePartialId: '部分添加（ID区间）',
  codeRangeRequired: '请输入二维码范围',
  serialRange: '流水号区间',
  idRange: '二维码ID区间',
  serialStartPlaceholder: '开始流水号',
  serialEndPlaceholder: '结束流水号',
  idStartPlaceholder: '开始ID',
  idEndPlaceholder: '结束ID',
  rangeStartPlaceholder: '开始序号',
  rangeEndPlaceholder: '结束序号',
  scopeRemarkPlaceholder: '请输入活动范围备注',
  invalidRange: '结束序号必须大于开始序号',
  serialRangeInvalid: '开始流水号不得大于结束流水号',
  confirmDeleteRange: '确认删除该活动范围？',
  codeBatchNo: '批次号',
  codeBatchName: '批次名称',
  // 步骤3 - 活动奖项
  addPrize: '添加奖项',
  addPrizeTitle: '添加奖项',
  editPrizeTitle: '编辑奖项',
  editPrize: '编辑',
  deletePrize: '删除',
  confirmDeletePrize: '确认删除该奖项？',
  prizeEmptyText: '暂无奖项数据',
  prizeName: '奖项名称',
  prizeNameRequired: '请输入奖项名称',
  prizeNamePlaceholder: '请输入奖项名称',
  prizeProbability: '中奖概率',
  prizeProbabilityPlaceholder: '请输入中奖概率',
  prizeCount: '奖品数量',
  prizeCountPlaceholder: '请输入奖品数量',
  prizeContent: '奖项内容',
  pointsLabel: '积分',
  giftLabel: '礼品',
  strategyOnly: '仅策略中奖',
  prizeImage: '奖项图片',
  prizePoints: '积分',
  prizeGift: '礼品名称',
  prizeGiftPlaceholder: '请选择礼品',
  prizeIcon: '奖项图标',
  prizeIconRequired: '请上传奖项图标',
  prizePointsPlaceholder: '请输入积分数量',
  prizeProbabilityRequired: '请输入中奖概率',
  prizeCountRequired: '请输入奖品数量',
  prizeContentRequired: '请至少选择一项奖项内容',
  prizeGiftRequired: '请选择礼品',
  prizePointsRequired: '请输入积分数量',
  selectGift: '选择礼品',
  giftNameCol: '礼品名称',
  giftCategoryCol: '礼品分类',
  // 步骤4 - 活动策略
  addStrategy: '添加策略',
  addStrategyTitle: '添加策略',
  editStrategyTitle: '编辑策略',
  editStrategy: '编辑',
  deleteStrategy: '删除',
  confirmDeleteStrategy: '确认删除该策略？',
  strategyEmptyText: '暂无策略数据',
  strategyStatus: '策略状态',
  strategyName: '策略名称',
  strategyNameRequired: '请输入策略名称',
  strategyNamePlaceholder: '请输入策略名称',
  strategyDetail: '策略详情',
  specifyCountry: '指定国家/地区',
  specifyCountryPlaceholder: '请输入国家/地区',
  strategyType: '策略类型',
  strategyRules: '策略规则',
  ruleType: '策略规则',
  ruleContent: '策略规则内容',
  ruleEmptyText: '暂无策略规则',
  ruleFormPlaceholder: '规则配置待补充',
  typeCountry: '指定国家/地区发奖',
  typeCountryDesc: '指定行政区域或GPS范围内用户可中奖',
  typeMemberLevel: '指定会员等级发奖',
  typeMemberLevelDesc: '指定会员等级的用户可中奖',
  typeUserLimit: '单用户指定次数发奖',
  typeUserLimitDesc: '活动周期内，任意用户最多中奖N次',
  typeTimePeriod: '指定时间段发奖',
  typeTimePeriodDesc: '活动周期内，在指定时间段内可中奖',
  memberLevel: '会员等级',
  memberLevelPlaceholder: '请选择会员等级',
  countryRegion: '国家/地区',
  countryPlaceholder: '请选择国家',
  regionPlaceholder: '请选择一级行政区',
  timePeriod: '时间周期',
  timePeriods: '时间段',
  currentActivityPeriod: '当前活动周期内',
  userLimitCount: '单用户累计次数',
  nthLabel: '第',
  scanParticipate: '次扫码参与',
  timeType: '时间类型',
  timeTypeDaily: '按天',
  timeTypeWeekly: '按周',
  timeTypeCustom: '指定时间范围',
  selectWeekDays: '选择日期',
  selectDateRange: '选择日期',
  startDate: '开始日期',
  endDate: '结束日期',
  weekDayMon: '周一',
  weekDayTue: '周二',
  weekDayWed: '周三',
  weekDayThu: '周四',
  weekDayFri: '周五',
  weekDaySat: '周六',
  weekDaySun: '周日',
};
